import { useQuery } from '@tanstack/react-query';

import { StorageKeys } from '@/services/storage';
import { useStorageValue } from '@/services/storage/react';
import { detectEnvironment } from '@/shared/lib/detectEnvironment';
import { downloadJsonFileFromDatalake } from '@/shared/lib/download/downloadJsonFileFromDatalake';

type LinkBarContent = {
  url?: string;
  message?: string;
};

const isLinkBarContent = (value: unknown): value is LinkBarContent => {
  return typeof value === 'object' && value !== null;
};

const useLinkBar = () => {
  const token = useStorageValue(StorageKeys.TripToken);
  const environment = detectEnvironment();

  const { data: fileContent } = useQuery({
    queryKey: [environment],
    queryFn: () =>
      downloadJsonFileFromDatalake(
        'LinkBar.json',
        `Meta_Go_Config${environment === 'staging' ? '_Staging' : ''}`
      ),
    gcTime: Infinity,
    enabled: !!token
  });

  const content = isLinkBarContent(fileContent) ? fileContent : undefined;

  return { linkUrl: content?.url ?? '', linkMessage: content?.message ?? '' };
};
export default useLinkBar;
